let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cWZHg")).then(() => parcelRequire('8XZGW'));